import React from "react";
import { useNavigate } from "react-router-dom";
import { UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from "reactstrap";
import { useCurrencyFormatter } from "../../../../Components/Hooks/useCurrencyFormatter";

const STATUS_CONFIG = {
  saved:   { label: "Saved",   bg: "#d0e1fb", color: "#54647a" },
  paid:    { label: "Paid",    bg: "#d1fae5", color: "#065f46" },
  overdue: { label: "Overdue", bg: "#fee2e2", color: "#991b1b" },
};

const StatusBadge = ({ status }) => {
  const c = STATUS_CONFIG[status] || { label: status || "Draft", bg: "#ffddba", color: "#c6955e" };
  return (
    <span className="badge fw-bold text-uppercase" style={{ fontSize: "0.6rem", letterSpacing: "0.05em", background: c.bg, color: c.color }}>
      {c.label}
    </span>
  );
};

const CategoryTag = ({ name }) => (
  <span className="d-inline-flex align-items-center gap-1 px-2 py-1 rounded small fw-medium"
    style={{ background: "#dce8ff", color: "#002045", fontSize: "0.75rem" }}>
    <i className="ri-magic-line" style={{ fontSize: "0.7rem" }} />
    {name || "—"}
  </span>
);

const InvoiceRow = ({ invoice, onEdit, onDelete, showVendorLink = true }) => {
  const navigate = useNavigate();
  const { formatCurrency } = useCurrencyFormatter();

  return (
    <tr style={{ borderBottom: "1px solid #f0f2f4" }}>
      <td
        className="px-4 py-4"
        style={showVendorLink ? { cursor: "pointer" } : undefined}
        onClick={showVendorLink ? () => navigate(`/financial/invoices/vendors/${encodeURIComponent(invoice.cif)}`, { state: { vendorName: invoice.name } }) : undefined}
      >
        <div className="fw-bold small" style={showVendorLink ? { color: "#1a56db", textDecoration: "underline" } : { color: "#002045" }}>{invoice.name || "—"}</div>
        <div className="text-muted" style={{ fontSize: "0.75rem" }}>{invoice.document || "—"}</div>
      </td>

      <td className="px-4 py-4"><CategoryTag name={invoice.category_detail?.name} /></td>
      <td className="px-4 py-4"><CategoryTag name={invoice.sub_category_detail?.name} /></td>
      <td className="px-4 py-4 small text-muted">{invoice.phase_detail?.name  || "—"}</td>
      <td className="px-4 py-4 small text-muted">{invoice.block_detail?.name  || "—"}</td>
      <td className="px-4 py-4 small text-muted">{invoice.issue_date           || "—"}</td>
      <td className="px-4 py-4 small text-muted">{invoice.due_date             || "—"}</td>
      <td className="px-4 py-4 text-end fw-bold small" style={{ color: "#002045" }}>
        {formatCurrency(invoice.total_amount || 0, invoice.currency || "EUR", false, false)}
      </td>
      <td className="px-4 py-4"><StatusBadge status={invoice.status} /></td>
      <td className="px-4 py-4 text-center">
        <UncontrolledDropdown>
          <DropdownToggle tag="button" className="btn btn-sm rounded-circle"
            style={{ color: "#74777f", background: "transparent", border: "none" }}
            onClick={(e) => e.stopPropagation()}>
            <i className="ri-more-fill fs-5" />
          </DropdownToggle>
          <DropdownMenu end strategy="fixed" container="body">
            <DropdownItem onClick={() => onEdit(invoice)}>
              <i className="ri-pencil-fill align-middle me-2" />Edit Invoice
            </DropdownItem>
            <DropdownItem divider />
            <DropdownItem onClick={() => onDelete(invoice)} className="text-danger">
              <i className="ri-delete-bin-5-fill align-middle me-2" />Delete Invoice
            </DropdownItem>
          </DropdownMenu>
        </UncontrolledDropdown>
      </td>
    </tr>
  );
};

export default InvoiceRow;
